import { type PageActionProps, usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { useBranchId } from './Context/hooks';

/**
 * Returns a Returns a <code>Page Action</code> analytics event with the
 * branch ID pre-propulated.
 */
export function useBranchedPageAction(baseProps?: Omit<PageActionProps, 'pageBranchName'>) {
  const branchId = useBranchId();
  const firePageAction = usePageAction({
    ...baseProps,
    pageBranchName: branchId,
  });
  return firePageAction;
}
